import Api from '@/api'

const api = new Api()

export default {
  // Decision Post =========================
  async submitDecision({ commit }, payload) {
    try {
      const resp = await api
        .sales()
        .decision()
        .submit(payload)
      commit('Dashboard/setFeedback', resp?.data?.data, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
    return false
  },
  async finalDecision({ commit }, payload) {
    try {
      const resp = await api
        .sales()
        .decision()
        .approval(payload)
      commit('Dashboard/setFeedback', resp?.data?.data, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
    return false
  },
}
